// Page buttons for <v-pagination>: every page up to 10, otherwise the first
// five, "...", and the last five - plus the current page and its neighbours
// when it sits in between, so you can always see where you are.
// e.g. 78 pages on page 1:  1 2 3 4 5 ... 74 75 76 77 78
//      78 pages on page 40: 1 2 3 4 5 ... 39 40 41 ... 74 75 76 77 78
export default function paginationItems(length, current, edge = 5) {
  const total = Number(length) || 0;
  if (total <= 0) return [];
  if (total <= edge * 2) return Array.from({ length: total }, (_, i) => i + 1);

  const pages = new Set();
  for (let p = 1; p <= edge; p++) pages.add(p);
  for (let p = total - edge + 1; p <= total; p++) pages.add(p);
  const page = Number(current) || 1;
  for (let p = page - 1; p <= page + 1; p++) {
    if (p >= 1 && p <= total) pages.add(p);
  }

  const items = [];
  let previous = 0;
  [...pages]
    .sort((a, b) => a - b)
    .forEach((p) => {
      if (p - previous === 2) items.push(previous + 1); // a gap of one page: show it, not "..."
      else if (p - previous > 2) items.push("...");
      items.push(p);
      previous = p;
    });
  return items;
}
